import GButton from "./";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsUpload from "../icons/upload";

const isNotCompact = (display) => display !== "compact";

<template>
  <GButton
    @type={{@type}}
    @color="outline"
    @disabled={{@disabled}}
    @loading={{@loading}}
    @display={{if @display @display "default"}}
    {{mergeClasses}}
    ...attributes
  >
    <div class="flex items-center">
      <IconsUpload class="w-4 mr-2.5 {{if (isNotCompact @display) '-ml-0.5'}} -mt-px text-indigo-700" />
      <span>
        {{yield}}
      </span>
    </div>
  </GButton>
</template>
